import React from 'react'
import { connect } from 'react-redux'

import { getCurrentScreen, getNextScreen, setReadyTriggerScreenOnReady } from '../../store/screenSlice'
import screens from '../../screens'


/* eslint react/prop-types: ["off"] */
function ScreenBody({ currentScreen, nextScreen }) {
    return (
        <>
            {
                Object.keys(screens).reverse().map((screenKey) => {
                    const Component = screens[screenKey]
                    const isCurrent = screenKey === currentScreen
                    const isNext = screenKey === nextScreen
                    const isExist = isCurrent || isNext

                    if (!isExist) {
                        return <div key={screenKey} />
                    }

                    return (
                        <div key={screenKey} className={screenKey}>
                            <Component isVisible={isCurrent} />
                        </div>
                    )
                })
            }
        </>
    )
}

export const Screens = connect(state => ({
    currentScreen: getCurrentScreen(state),
    nextScreen: getNextScreen(state),
}), {
    setReadyTriggerScreenOnReady,
})(ScreenBody)
